import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ReviewActionItemTypesCreate, ReviewActionItemTypesDelete, ReviewActionItemTypesRefresh, ReviewActionItemTypesUpdate } from './review-action-item-types.action';
import { ReviewsService } from '../../reviews.service';
import { ReviewActionItemType } from '../../reviews.models';

export class ReviewActionItemTypesStateModel {
  data: ReviewActionItemType[] = [];
}

@State<ReviewActionItemTypesStateModel>({
  name: 'ReviewActionItemTypes',
  defaults: {
    data: []
  }
})
@Injectable()
export class ReviewActionItemTypesState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ReviewsService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ReviewActionItemTypesStateModel) {
    return state.data;
  }

  @Action(ReviewActionItemTypesRefresh)
  refresh({ patchState }: StateContext<ReviewActionItemTypesStateModel>) {
    this._service.getReviewActionItemTypes().subscribe(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(ReviewActionItemTypesCreate)
  create({ getState, patchState }: StateContext<ReviewActionItemTypesStateModel>, { item }: ReviewActionItemTypesCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(ReviewActionItemTypesUpdate)
  update({ getState, patchState }: StateContext<ReviewActionItemTypesStateModel>, { id, item }: ReviewActionItemTypesUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ReviewActionItemTypesDelete)
  delete({ getState, patchState }: StateContext<ReviewActionItemTypesStateModel>, { id }: ReviewActionItemTypesDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
